module.exports = __webpack_public_path__ + "static/media/albanil.677ccc96.png";